<template lang="pug">
div
    h2.titulo-bloco-dados-car Dados do CAR
    .container-conteudo
        .dados
            el-collapse(
                v-model='indicesCollapseConsolidadoTerritorio',
                @change='addGeometriaTerritorio',
                v-if='dadosTerritorio?.consolidadoTerritorio'
            )
                el-collapse-item(:name='`collapse-consolidado-territorio`')
                    template(slot='title')
                        h3.titulo-collapse Consolidado do território
                    .collapse-item-bloco-info
                        .info
                            label Área total do território:
                            span {{ formatNumber(dadosTerritorio?.consolidadoTerritorio?.areaHa) }}
                        .info
                            label Área total de plantio:
                            span {{ dadosTerritorio?.consolidadoTerritorio?.areaPlantio ? formatNumber(dadosTerritorio?.consolidadoTerritorio?.areaPlantio) : 'Não possui' }}
                    CollapseReservaLegal(
                        :dados='dadosTerritorio?.consolidadoTerritorio?.reservaLegal || {}'
                    )
                    CollapseAreaPreservacaoPermanente(
                        :dados='dadosTerritorio?.consolidadoTerritorio?.app || {}'
                    )
                    CollapseListaDocumentos(
                        :dados='dadosTerritorio?.consolidadoTerritorio?.app || {}',
                        :arquivos='arquivosCertificacao',
                        :dadosCertificacao='dadosCertificacao',
                        :dadosTerritorio='dadosTerritorio'
                    )

            el-collapse(
                v-model='indicesCollapseCar',
                @change='addGeometriaCar(indicesCollapseCar)',
                v-if='dadosTerritorio?.resultadosCars'
            )
                el-collapse-item(
                    :name='`collapse-car-${index}`',
                    :key='index',
                    v-for='(car, index) in dadosTerritorio?.resultadosCars'
                )
                    template(slot='title')
                        h3.titulo-collapse {{ car?.codigo }}
                    .collapse-item-bloco-info
                        .info
                            label Área do imóvel:
                            span {{ formatNumber(car?.areaHa, 2) }}
                        .info
                            label Situação do cadastro:
                            span {{ car?.situacao || '-' }}
                        .info
                            label Condição do cadastro:
                            span {{ car?.condicao || '-' }}
                    CollapseReservaLegal(:dados='car.reservaLegal || {}')
                    CollapseAreaPreservacaoPermanente(:dados='car.app || {}')
        .mapa
            mapa(
                ref='mapa',
                :showStatesLayers='false',
                :mapLayersConfigs='layersMap',
                :mapConfig='mapConfig',
                :height='"100%"',
                :idMapa='"mapaDadosCarCertificacao"',
                :atualizarMapa='true'
            )
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import CollapseReservaLegal from './CollapseReservaLegal.vue';
import CollapseAreaPreservacaoPermanente from './CollapseAreaPreservacaoPermanente.vue';
import CollapseListaDocumentos from './CollapseListaDocumentos.vue';
import formatter from '@/utils/formatters';

const LAYER_CONSOLIDADO_TERRITORIO = 'layer-consolidado-territorio';
const LAYER_CAR = 'layer-car-';
const YELLOW = 'yellow';
const LIGHT_GREEN = '#00FF00';
const TIPO_GEOMETRIA = {
    TERRITORIO: 'TERRITORIO',
    AREA_PLANTADA: 'AREA_PLANTADA'
};

export default {
    name: 'DadosCar',
    components: {
        Mapa,
        CollapseReservaLegal,
        CollapseAreaPreservacaoPermanente,
        CollapseListaDocumentos
    },
    props: {
        dadosTerritorio: {
            type: Object,
            required: true
        },
        arquivosCertificacao: {
            type: Array,
            required: true
        },
        dadosCertificacao: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            layersMap: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    bufferControl: false
                }
            },
            indicesCollapseConsolidadoTerritorio: [
                'collapse-consolidado-territorio'
            ],
            indicesCollapseCar: [],
            copiaIndicesCollapseCar: []
        };
    },
    mounted() {
        this.abrirCollapseConsolidadoTerritorio();
    },
    methods: {
        formatNumber(number, decimalPlaces = 2) {
            if (!number) return '-';
            return formatter.formatNumber(number, decimalPlaces) + ' ha';
        },
        addGeometriaCar(arrayCollapseCarAbertos) {
            const collapsesAbertos = this.getIndicesCollapsesAbertos(
                arrayCollapseCarAbertos
            );

            if (this.copiaIndicesCollapseCar.length < collapsesAbertos.length) {
                this.addLayerCar(arrayCollapseCarAbertos);
            } else {
                this.removerLayerCar();
            }
        },
        getIndicesCollapsesAbertos(indices) {
            return indices.filter(i => i !== '');
        },
        addLayerCar(arrayCollapseCarAbertos) {
            const nomeUltimoCollapseAberto =
                arrayCollapseCarAbertos[arrayCollapseCarAbertos.length - 1];
            const index = this.getIndexCar(nomeUltimoCollapseAberto);

            if (index !== null) {
                this.addLayer(
                    this.dadosTerritorio.resultadosCars[index].geometria,
                    TIPO_GEOMETRIA.TERRITORIO,
                    LAYER_CAR + index
                );

                if (
                    this.dadosTerritorio.resultadosCars[index]
                        .geometriaAreaPlantada
                ) {
                    this.addLayer(
                        this.dadosTerritorio.resultadosCars[index]
                            .geometriaAreaPlantada,
                        TIPO_GEOMETRIA.AREA_PLANTADA,
                        LAYER_CAR + index
                    );
                }

                this.copiaIndicesCollapseCar = this.getIndicesCollapsesAbertos(
                    this.indicesCollapseCar
                );
            }
        },
        removerLayerCar() {
            const nomeCollapseRemovido = this.copiaIndicesCollapseCar.find(
                copia => !this.indicesCollapseCar.includes(copia)
            );
            const index = this.getIndexCar(nomeCollapseRemovido);

            if (index !== null) {
                this.removerLayer(LAYER_CAR + index);
                this.copiaIndicesCollapseCar = this.getIndicesCollapsesAbertos(
                    this.indicesCollapseCar
                );
            }
        },
        getIndexCar(nomeCollapse) {
            const indexUltimoSeparador = nomeCollapse.lastIndexOf('-');
            return Number(nomeCollapse.substring(indexUltimoSeparador + 1));
        },
        addLayer(geometria, tipoGeometria, nomeLayer) {
            if (geometria && nomeLayer) {
                const style = {
                    color:
                        tipoGeometria === TIPO_GEOMETRIA.TERRITORIO
                            ? LIGHT_GREEN
                            : YELLOW,
                    weight: 1,
                    fill: tipoGeometria === TIPO_GEOMETRIA.AREA_PLANTADA,
                    opacity: 100 / 200,
                    fillOpacity: 100 / 200
                };

                this.layersMap.push({
                    id: 'centroid' + Math.random(),
                    name: nomeLayer,
                    geoJson: geometria,
                    style
                });
            }
        },
        removerLayer(nomeLayer) {
            const updatedLayersMaps = this.layersMap.filter(
                l => l.name !== nomeLayer
            );
            this.layersMap = updatedLayersMaps;
        },
        addGeometriaTerritorio() {
            if (this.indicesCollapseConsolidadoTerritorio.length) {
                this.addLayerTerritorio();
            } else {
                this.removerLayer(LAYER_CONSOLIDADO_TERRITORIO);
            }
        },
        addLayerTerritorio() {
            if (this.dadosTerritorio?.consolidadoTerritorio?.geometria) {
                this.addLayer(
                    this.dadosTerritorio?.consolidadoTerritorio?.geometria,
                    TIPO_GEOMETRIA.TERRITORIO,
                    LAYER_CONSOLIDADO_TERRITORIO
                );
            }

            if (
                this.dadosTerritorio?.consolidadoTerritorio
                    ?.geometriaAreaPlantada
            ) {
                this.addLayer(
                    this.dadosTerritorio?.consolidadoTerritorio
                        ?.geometriaAreaPlantada,
                    TIPO_GEOMETRIA.AREA_PLANTADA,
                    LAYER_CONSOLIDADO_TERRITORIO
                );
            }
        },
        abrirCollapseConsolidadoTerritorio() {
            this.dadosTerritorio.consolidadoTerritorio
                ? this.addLayerTerritorio()
                : setTimeout(this.abrirCollapseConsolidadoTerritorio, 1500);
        }
    }
};
</script>

<style lang="scss">
.titulo-bloco-dados-car {
    font-weight: bold;
    margin: 1rem 0;
}

.container-conteudo {
    display: flex;
    gap: 20px;
    height: 500px;

    .dados,
    .mapa {
        flex: 1;
        border-radius: $default-border-radius;
    }

    .dados {
        .el-collapse-item__header {
            background: $white;

            .titulo-collapse {
                font-size: 16px;
                font-weight: bold;
                color: var(--primary-font-color);
            }
        }

        .collapse-item-bloco-info {
            display: flex;
            justify-content: flex-start;
            gap: 20px;
            background: $white;

            .info {
                display: flex;
                flex-direction: column;

                label {
                    color: var(--primary-font-color);
                }

                span {
                    font-weight: bold;
                    color: var(--primary);
                }
            }
        }
    }
}
</style>
